import { createAction } from '@reduxjs/toolkit';
import {
  actionTypes as routerActionTypes,
  router5Middleware as routerMiddleware,
  router5Reducer as routerReducer,
} from 'redux-router5';
import createRouter, {
  NavigationOptions,
  Route,
  RouteNode,
  Router,
} from 'router5';
import browserPlugin from 'router5-plugin-browser';
import { ImportedAppModule, unwrapModules } from './appModule';
import { errorRouteDefs } from './error';

let router: Router | null = null;

type State = ReturnType<typeof routerReducer>;

export type RouterOptions = {
  modules?: ImportedAppModule[];
};

export const mainRoutes = {
  HOME: 'home',
};

const mainRouteDefs: Route[] = [
  {
    name: mainRoutes.HOME,
    path: '/stud-reg-form',
  },
];

export const configureRouter = async (options: RouterOptions) => {
  const modules = await unwrapModules(options.modules ?? []);

  const routeDefs: Route[] = [...mainRouteDefs, ...errorRouteDefs];

  for (const module of modules) {
    if (!module.routeDefs) {
      continue;
    }
    for (const routeDef of module.routeDefs) {
      routeDefs.push(routeDef);
    }
  }

  console.debug('configureRouter/routeDefs', routeDefs);

  router = createRouter(routeDefs, {
    allowNotFound: false,
  });

  router.usePlugin(browserPlugin({}));

  return router;
};

export const getRouter = () => {
  if (!router) {
    throw new Error('Router is not configured.');
  }
  return router;
};

export const buildUrl: Router['buildUrl'] = (name, params) => {
  return getRouter().buildUrl(name, params);
};

export const selectRouter = (state: any) => state.router as State | null;
export const selectRoute = (state: any) => selectRouter(state)?.route ?? null;

export type NavigateToPayload = {
  name: string;
  params?: Record<string, any>;
  opts?: NavigationOptions;
};

/** Reimplementation of Router5 navigateTo using Redux Toolkit. */
export const navigateTo = createAction<NavigateToPayload>(
  routerActionTypes.NAVIGATE_TO,
);

export { routerActionTypes, routerMiddleware, routerReducer };
